<template>
    <div class="change-pwd-dialog">
        <div class="change-pwd-wrapper">
            <el-form
                class="dialog-content"
                :model="form"
                :rules="rules"
                ref="form"
            >
                <div class="dialog-content__title">设置密码</div>
                <div class="dialog-content__item">
                    <div class="dialog-content__item-title">
                        <div class="label">原密码:</div>
                        <div class="description">（请先验证原密码）</div>
                    </div>
                    <div class="dialog-content__item-enter">
                        <el-form-item prop="oldPassword">
                            <el-input
                                type="password"
                                name="repassword"
                                show-password
                                v-model="form.oldPassword"
                            />
                        </el-form-item>
                    </div>
                </div>
                <div class="dialog-content__item">
                    <div class="dialog-content__item-title">
                        <div class="label">新密码:</div>
                        <div class="description">（最小长度6个字符）</div>
                    </div>
                    <div class="dialog-content__item-enter">
                        <el-form-item prop="newPassword">
                            <el-input
                                type="password"
                                name="repassword"
                                show-password
                                v-model="form.newPassword"
                            />
                        </el-form-item>
                    </div>
                </div>
                <div class="dialog-content__item">
                    <div class="dialog-content__item-title">
                        <div class="label">确认密码:</div>
                    </div>
                    <div class="dialog-content__item-enter">
                        <el-form-item prop="repassword">
                            <el-input
                                type="password"
                                name="repassword"
                                show-password
                                v-model="form.repassword"
                            />
                        </el-form-item>
                    </div>
                </div>
                <el-button type="primary" class="dialog-content__button" :loading="submitLoading" @click="handleSubmit">确定</el-button>
            </el-form>
            <div class="close-control" @click="closeDialog">
                <svg-icon icon-class="close" class-name="icon-close"></svg-icon>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { updatePassword } from '@/api/user';

export default {
    name: 'ChangePwdDialog',
    inject: ['reload'],
    data() {
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                if (this.form.repassword !== '') {
                    this.$refs.form.validateField('repassword');
                }
                callback();
            }
        };
        const validateRepassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newPassword) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        return {
            submitLoading: false,
            form: {
                oldPassword: '',
                newPassword: '',
                repassword: ''
            },
            rules: {
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: ['blur', 'change'] }
                ],
                newPassword: [
                    { min: 6, max: 16, message: '密码长度为6-16个字符', trigger: ['blur', 'change'] },
                    { validator: validatePassword, trigger: ['blur', 'change'] }
                ],
                repassword: [
                    { validator: validateRepassword, trigger: ['blur', 'change'] }
                ]
            },
        };
    },
    computed: {
        ...mapState('user', ['userInfo'])
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const params = {
                        id: this.userInfo.id,
                        ...this.form
                    }
                    this.submitLoading = true;
                    updatePassword(params)
                        .then(({ code }) => {
                            if (code === 0) {
                                this.$message.success('修改成功');
                                this.$store.dispatch('user/LogOut');
                            }
                        })
                        .finally(() => {
                            this.submitLoading = false;
                        });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.change-pwd-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.35);

    .change-pwd-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        width: 501px;
        height: 572px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        padding: 64px 70px;

        .close-control {
            position: absolute;
            top: 20px;
            right: 25px;
            cursor: pointer;

            .icon-close {
                font-size: 15px;
                color: rgba(47, 84, 235, 0.5);

                &:hover {
                    color: rgba(47, 84, 235, 0.8);
                }
            }
        }

        .dialog-content {
            width: 100%;
            .label {
                @include font(rgba(39, 44, 64, 1), 16px, 600);
            }

            .description {
                @include font(rgba(145, 145, 145, 1), 14px, 400);
            }

            &__button {
                width: 100%;
                height: 50px;
                margin-top: 40px;
                @include font(rgba(255, 255, 255, 1), 16px, 600);
            }

            &__title {
                @include font(rgba(47, 84, 235, 1), 20px, 600);
            }

            &__item {
                width: 100%;
                margin-top: 20px;

                &-title {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;

                    .label {
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
.dialogFade-enter-active,
.dialogFade-leave-active {
    transition: opacity 0.4s;
}

.dialogFade-enter,
.dialogFade-leave-active {
    opacity: 0;
}
</style>
